import { useEffect, useState, lazy, Suspense } from "react";
import Sidebar from "../../Components/Sidebar";
import CustomTextInput from "../../Components/CustomTextInput";
import {
  Button,
  notification,
  Select,
  TimePicker,
} from "antd";
import arrowleft from "../../assest/arrow-left.png";
import exchange from "../../assest/exchange.png";

import smallpreviewpic from "../../assest/small preview pic.png";
import { Form, DatePicker } from "antd";

import CampaignNotification from "../../Components/Notification/CampaignNotification";
import CampaignMessagepreview from "../../Components/Modal/CampaignMessagepreview";
import CampaignMessage from "../../Components/Modal/CampaignMessage";
import { useSelector } from "react-redux";

import { getTemplate } from "../../redux/actions/templateaction";
import { addCampagin, EditCampagin } from "../../redux/actions/campaignaction";
import moment from "moment-timezone";

import { useLocation } from "react-router-dom";
import { getUserGroup } from "../../redux/actions/groupcampaignAction";
import { getUser } from "../../redux/actions/authAction";

// Dynamically import react-slick

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from "react-icons/io";
import CampaignMessagepreview2 from "../../Components/Modal/CampaignMessagepreview2";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { getDomain } from "../../redux/actions/domainAction";
import { getLoginTemplate } from "../../redux/actions/loginTemplateAction";
const { Option } = Select;

const Slider = lazy(async () => {
  const module = await import("react-slick");
  return module;
});
const FreeusercampaignFlow = () => {
  const location = useLocation();
  const campaign = location.state?.campaign;
  const [name, setName] = useState("");
  const userdetails = useSelector((state) => state?.Auth?.userDetails?.data);
  const [form] = Form.useForm();


  const usergroup = useSelector((state) => state?.Groupreducer?.AllusersGroups);

  const alltemplate =
    useSelector((state) => state?.Templatereducer?.AllTemplate) || {};

  const [currentStep, setCurrentStep] = useState("comptitle");

  const [, setcampaignTemplate] = useState(false);


  // const [dateRange, setDateRange] = useState([null, null]);
  const [notificationmodal, setNotificationmodal] = useState(false);
  const [messagepreview, setmessagepreview] = useState(false);
  const [messagepreview2, setmessagepreview2] = useState(false);
  const [message, setMessage] = useState(false);
  const [campaignmessage, setcampaignmessage] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeIndexlink, setActiveIndexlink] = useState(null);
  const [selectedtemplate, setSelectedTempalte] = useState(null);
  const [selecteddomain, setSelecteddomain] = useState(null);
  const [selectedlogintemplate, setSelectedloginTempalte] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const NextArrow = ({ onClick }) => (
    <div className='custom-arrow next' onClick={onClick}>
      <IoIosArrowRoundForward size={30} />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className='custom-arrow prev'
      onClick={() => {
        onClick && onClick(); // Ensure function runs
      }}
    >
      <IoIosArrowRoundBack size={30} />
    </div>
  );

  const filteredTemplates =
    alltemplate?.template?.filter((item) => item.type === "text") || [];
  const filteredTemplates2 =
    alltemplate?.template?.filter((item) => item.type === "link") || [];

  const slidesToShow = 3; // Always show space for 3 slides

  // Ensure we always have at least 3 elements
  const filledTemplates =
    filteredTemplates.length < slidesToShow
      ? [
          ...filteredTemplates,
          ...new Array(slidesToShow - filteredTemplates.length).fill(null),
        ]
      : filteredTemplates;

  const filledTemplates2 =
    filteredTemplates2.length < slidesToShow
      ? [
          ...filteredTemplates2,
          ...new Array(slidesToShow - filteredTemplates2.length).fill(null),
        ]
      : filteredTemplates2;

  const settings = {
    dots: filteredTemplates.length >= 3, // Show dots only if at least 3 items
    arrows: filteredTemplates.length >= 3, // Hide arrows if only one item
    infinite: filteredTemplates.length > 1, // Prevent infinite scroll on single item
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: "10px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,

    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings2 = {
    dots: filteredTemplates2.length >= 3, // Show dots only if at least 3 items
    arrows: filteredTemplates2.length >= 3, // Hide arrows if only one item
    infinite: filteredTemplates2.length > 1, // Prevent infinite scroll on single item
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: "10px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,

    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Handle selection change
  const handleSelectChange = (value) => {
    // setSelectedUsers(value); // Update selected user IDs

    const selectedUserObjects = usergroup.usergroup.filter((user) =>
      value.includes(user._id)
    );
    setSelectedUsers(selectedUserObjects);
  };


  const [date, setDate] = useState(null);

  const [time, setTime] = useState(null);

  // const handleDateChange = (date, dateString) => {
  //     setDate(dateString);
  //     setTime(null)
  //     form.setFieldsValue({ dateRange: dateString });
  // };

  useEffect(() => {
    let organizationid = localStorage.getItem("organizationid");
    let page = 1;
    let payload = { organizationid, page };
    getUserGroup(payload);
    getTemplate(payload);
    getUser(organizationid);
    getDomain(payload);
    getLoginTemplate(payload);
  }, []);

  useEffect(() => {       
    if (campaign) {
      const createdDate = new Date(campaign.createdDate); // Ensure the date is properly parsed
      const selectedTemplateIndex = alltemplate?.template?.findIndex(
        (template) => template._id === campaign.messageid._id
      );

  
      if (selectedTemplateIndex !== -1) {
        setActiveIndex(selectedTemplateIndex);
      }

      // If the createdDate is valid, you can set it in the DatePicker
      if (!isNaN(createdDate.getTime())) {
        let localDate = `${createdDate.getFullYear()}-${(
          createdDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${createdDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;
        setDate(localDate);

        // Extract the local time part (HH:MM:SS)
        let localTime = `${createdDate
          .getHours()
          .toString()
          .padStart(2, "0")}:${createdDate
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${createdDate
          .getSeconds()
          .toString()
          .padStart(2, "0")}`;
        setTime(localTime);

        // Convert to moment if needed

        // Set the form fields
        form.setFieldsValue({
          campaignTitle: campaign?.name, // Set the campaign name
          message: campaign?.message._id, // Set the campaign message
          targetGroups: campaign?.targetGroup?.map((user) => user._id),
          template: campaign?.message, // Set the target groups
          //  date: date,                 // Set the date for DatePicker
          // time: time // Optionally set the time
        });

        // Store selected data
        setName(campaign.name);
        setSelectedUsers(campaign.targetGroup);
        setSelectedTempalte(campaign?.messageid);
        //  setDate(formattedDate);                // Set the date
        //  setTime(createdDate.toLocaleTimeString()); // Optionally set time
        // setDate(formattedDate);
        //  setTime(localTime);
      } else {
        console.error("Invalid createdDate:", campaign.createdDate);
      }
    }
  }, [campaign, form, activeIndexlink, activeIndex, alltemplate?.template]);


  const handleStepClick = (step) => {
    // First, validate the form fields
    form
      .validateFields()
      .then(() => {
        if (step === "review") {
          if (date === null || time === null) {
            notification.error({
              message: "Please select both a date and a time..",
              duration: 3,
            });

            return;
          }
        }

        setCurrentStep(step);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const handlebackClick = (step) => {
    setCurrentStep(step);
  };

  // const handleRangeChange = (dates, dateStrings) => {
  //     setDateRange(dates);
  //     form.setFieldsValue({ dateRange: dates });
  // };

  const handleClick = (item) => {
    setSelecteddomain(null);
    setSelectedloginTempalte(null);
    setActiveIndexlink(null);
    setActiveIndex(item?._id);
    setSelectedTempalte(item);
    setmessagepreview(true);
    form.setFieldsValue({ template: item });
  };

  const handleClick2 = (item) => {
    // setSelecteddomain(null)
    // setSelectedloginTempalte(null)
    setActiveIndex(item?._id);
    setActiveIndexlink(null);
    setSelectedTempalte(item);
    setmessagepreview2(true);
    form.setFieldsValue({ template: item });
  };

  // const formatDisplay = (dates) => {
  //     if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
  //         return '';
  //     }
  //     return `${dates[0].format('MM/DD/YYYY')} - ${dates[1].format('MM/DD/YYYY')} ${dates[0].format('hh:mm A')} - ${dates[1].format('hh:mm A')}`;
  // };

  // const handleSelectChange = (value) => {
  //     // Find the user object that matches the selected user ID
  //     const selectedUser = usergroup.usergroup.find((user) => user._id === value);
  //     setSelectedOption(selectedUser); // Store the entire user object in the state
  //   };

  const disablePastDates = (current) => {
    // Disable dates before today
    return current && current < moment().startOf("day");
  };

  // Disable past times for TimePicker
  // const disablePastTimes = () => {
  //     const currentTime = moment();
  //     return {
  //         disabledHours: () => {
  //             // Disable hours less than the current hour
  //             return Array.from({ length: currentTime.hour() }).map((_, index) => index);
  //         },
  //         disabledMinutes: (hour) => {
  //             if (hour === currentTime.hour()) {
  //                 // Disable minutes before the current minute for the current hour
  //                 return Array.from({ length: currentTime.minute() }).map((_, index) => index);
  //             }
  //             return [];
  //         },
  //         disabledSeconds: (hour, minute) => {
  //             if (hour === currentTime.hour() && minute === currentTime.minute()) {
  //                 // Disable seconds before the current second for the current minute
  //                 return Array.from({ length: currentTime.second() }).map((_, index) => index);
  //             }
  //             return [];
  //         },
  //     };
  // };

  const disablePastTimes = (selectedDate) => {
    const currentTime = moment();
    const selectedMoment = moment(selectedDate);

    return {
      disabledHours: () => {
        const hoursToDisable = [];
        const currentHour = currentTime.hour();

        // If the selected date is today, disable hours before the current hour
        if (selectedMoment.isSame(currentTime, "day")) {
          return Array.from({ length: currentHour }).map((_, index) => index);
        }
        // If the selected date is in the future, no hours need to be disabled
        return hoursToDisable;
      },
      disabledMinutes: (hour) => {
        const minutesToDisable = [];
        const currentMinute = currentTime.minute();

        // If the selected date is today and we're looking at the current hour,
        // disable minutes before the current minute
        if (
          selectedMoment.isSame(currentTime, "day") &&
          hour === currentTime.hour()
        ) {
          return Array.from({ length: currentMinute }).map((_, index) => index);
        }
        return minutesToDisable;
      },
      disabledSeconds: (hour, minute) => {
        const secondsToDisable = [];
        const currentSecond = currentTime.second();

        // If the selected date is today, and we're looking at the current minute,
        // disable seconds before the current second
        if (
          selectedMoment.isSame(currentTime, "day") &&
          hour === currentTime.hour() &&
          minute === currentTime.minute()
        ) {
          return Array.from({ length: currentSecond }).map((_, index) => index);
        }
        return secondsToDisable;
      },
    };
  };

  const savecampaign = async () => {
    let formattedDates;
    let organizationid = localStorage.getItem("organizationid");

    if (date && time) {
      // Combine the selected date and time
      const dateTimeString = `${date} ${time}`;

      // Convert the combined date-time string into a moment object
      const combinedDateTime = moment(dateTimeString, "YYYY-MM-DD HH:mm:ss");

      // Convert to US Eastern Time (ET) and format
      // formattedDates = combinedDateTime.tz('America/New_York').format('YYYY-MM-DD hh:mm:ss A');

      formattedDates = combinedDateTime.local().format("YYYY-MM-DD hh:mm:ss A");

    }

    let payload = null;

    if (campaign) {
      payload = {
        name,
        title: name,
        message: selectedtemplate?.message || campaignmessage,
        messageid: selectedtemplate._id,
        createdDate: formattedDates,
        targetGroup: selectedUsers.map((item) => item._id),
        organizationid: campaign.organizationid,
        id: campaign._id,

        // name, title, message, messageid, datesent,organizationid, targetGroup
      };



      const res = await EditCampagin(payload);

      if (res.data.success) {
        setNotificationmodal(true);
      }
    } else {
      payload = {
        name,
        title: name,
        message: selectedtemplate?.message || campaignmessage,
        messageid: selectedtemplate._id,
        createdDate: formattedDates,
        targetGroup: selectedUsers.map((item) => item._id),
        domainid: selecteddomain?._id,
        logintemplateid: selectedlogintemplate?._id,
        organizationid,

        // name, title, message, messageid, datesent,organizationid, targetGroup
      };



      const res = await addCampagin(payload);

      if (res.data.success) {
        setNotificationmodal(true);
      }
    }
  };

  return (
    <>
      <div className='maindiv'>
        <div>
          <Sidebar />
        </div>

        <div className='campaign-flow'>
          {/* <Sidebar /> */}

          <div className='campaign-flow-main space-y-12'>
            <div className='flex gap-3 items-center w-fit text-[#4A4D54]'>
              <button
                className='border-0 bg-transparent p-0 cursor-pointer flex items-center justify-center'
                onClick={() => window.history.back()}
              >
                <IoArrowBackCircleOutline size={28} />
              </button>
              <h5 className='text-2xl font-bold mb-0'>New Campaign</h5>
            </div>
            <div className='choices'>
              <div
                onClick={() => handleStepClick("comptitle")}
                className={
                  currentStep === "comptitle"
                    ? "choices-main-selected"
                    : "choices-main"
                }
              >
                <div className='circle'>1</div>
                <p>Add Title</p>
              </div>

              <div
                onClick={() => handleStepClick("targetuser")}
                className={
                  currentStep === "targetuser"
                    ? "choices-main-selected"
                    : "choices-main"
                }
              >
                <div className='circle'>2</div>
                <p>Target User</p>
              </div>

              <div
                onClick={() => handleStepClick("campaignTemplate")}
                className={
                  currentStep === "campaignTemplate"
                    ? "choices-main-selected"
                    : "choices-main"
                }
              >
                <div className='circle'>3</div>
                <p>Templates</p>
              </div>

              <div
                onClick={() => handleStepClick("daterange")}
                className={
                  currentStep === "daterange"
                    ? "choices-main-selected"
                    : "choices-main"
                }
              >
                <div className='circle'>4</div>
                <p>Date Range</p>
              </div>

              <div
                onClick={() => handleStepClick("review")}
                className={
                  currentStep === "review"
                    ? "choices-main-selected"
                    : "choices-main"
                }
              >
                <div className='circle'>5</div>
                <p>Review</p>
              </div>
            </div>

            <Form
              form={form}

              //initialValue={campaign?.name}
            >
              {currentStep === "comptitle" && (
                <div className='campaign-title mx-auto'>
                  <p className='p_Text'>Phishing Simulation Campaigns</p>
                  <p className='head_Text'>Create a Campaign Title</p>

                  <Form.Item
                    className='pt-3'
                    name='campaignTitle'
                    rules={[
                      {
                        required: true,
                        message: "campaign title is required!",
                      },
                    ]} // Validation for required field
                  >
                    <CustomTextInput
                      style={{ width: "100%" }}
                      required={true}
                      className='inputbox'
                      placeholder={"Enter Title here...."}
                      value={name}
                      //onChange={(e) => setName(e.target.value)}
                      onChange={setName}
                    />
                  </Form.Item>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Button
                      onClick={() => handleStepClick("targetuser")}
                      className='btn'
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              )}

              {currentStep === "targetuser" && (
                <div className='campaign-title'>
                  <p>Phishing Simulation Campaigns</p>
                  <h1>Select Target Groups for Campaign</h1>

                  {userdetails?.isFree ? (
                    <Form.Item
                      name='targetGroups'
                      rules={[
                        {
                          required: true,
                          message:
                            "At least one target group must be selected!",
                        },
                      ]}
                    >
                      <Select
                        placeholder='Select Group'
                        onChange={handleSelectChange}
                        value={selectedUsers?.map((user) => user._id)}
                        className='inputbox'
                        mode='multiple'
                        //  value={selectedUsers}
                        // style={{ width: '100%' }}
                      >
                        {usergroup?.usergroup?.map((user) => (
                          <Option key={user._id} value={user._id}>
                            {user.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  ) : (
                    <>
                      <p>You are currently on the free trial plan.  You are only able to text your own number for testing purposes.</p>

                      <CustomTextInput
                        type='number'
                        style={{ width: "100%" }}
                        disabled={true}
                        value={userdetails?.phone}
                        className='inputbox'
                      />
                    </>
                  )}

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Button
                      onClick={() => handlebackClick("comptitle")}
                      className='back-btn'
                    >
                      <img alt='' width={24} src={arrowleft} />
                      Back
                    </Button>
                    <Button
                      onClick={() => handleStepClick("campaignTemplate")}
                      className='btn'
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              )}

              {currentStep === "campaignTemplate" && (
                <div className='campaignTemplate'>
                  <div>
                    <div>
                      <p className='compheading ms-3'>
                        Phishing Simulation Campaigns
                        {/* <span onClick={() => handleStepClick('daterange')} className="skip">Skip This Step -></span> */}
                      </p>
                      <h1 className='compara ms-2'>
                        Select Template for Your Campaign
                      </h1>
                    </div>
                  </div>

                  <div className='filtertemplates'>
                    {/* <p>Templates</p> */}
                    {/* <div className="filtertemplatesflex">
                      <Image
                        style={{ width: "20px", height: "20px" }}
                        src={filter}
                      />

                      <Search
                        placeholder="Search user...."
                        onSearch={onSearch}
                        onPressEnter={(e) => onSearch(e.target.value)}
                        enterButton
                      />
                    </div> */}
                  </div>
                  <Form.Item
                    name='template'
                    rules={[
                      {
                        required: true,
                        message: "Template selection is required!",
                      },
                    ]} // Validation
                  >
                    <div className='tempalatmainebox'>
                      <p className='heading ms-3'>Link Templates</p>   
                      <p className="heading ms-3" style={{color: "#ef4444"}}>A deceptive text message containing a malicious link designed to trick recipients into revealing personal or financial information.</p>   
                      <Suspense fallback={<div>Loading slider...</div>}>
                        <Slider
                          {...settings2}
                          appendDots={(dots) => (
                            <div className='custom-dots-container'>
                              <ul className='custom-dots'>{dots}</ul>
                            </div>
                          )}
                          customPaging={(i) => (
                            <div className='custom-dot'>
                              <span></span>
                            </div>
                          )}
                        >
                          {filledTemplates2.map((item, index) => (
                            <div key={item?._id} className='template-slide'>
                              {item ? (
                                <div
                                  onClick={() => handleClick2(item, index)}
                                  className={`tempaltebox ${
                                    activeIndex === item?._id
                                      ? "active-tempaltebox"
                                      : ""
                                  }`}
                                >
                                  <h4 className='name ms-2'>{`${String(
                                    index + 1
                                  ).padStart(2, "0")}. ${item?.name}`}</h4>
                                  <p className='text-[#6D727D] ms-2 min-h-[24px]'>
                                  {item?.description || ' '}
                                  </p>

                                  <div className='message-box'>
                                    <img
                                      src={smallpreviewpic}
                                      alt='Preview'
                                      className='template-image'
                                    />
                                    <p className='message min-h-10 overflow-auto'>
                                      {item?.message} <br />
                                      <span className="text-blue-500 underline underline-offset-2">  {selecteddomain?.url || "Your Link Here"}</span>
                                    </p>
                                  </div>
                                </div>
                              ) : (
                                <div className='empty-slide'></div> // Empty placeholder for missing items
                              )}
                            </div>
                          ))}
                        </Slider>
                      </Suspense>
                    </div>

                    <div className='tempalatmainebox'>
                      <p className='heading ms-3'>Text Templates</p>
                      <p className="heading ms-3" style={{color: "#ef4444"}}>A deceptive text message that attempts to trick recipients into revealing sensitive information without using links.</p>
                      <Suspense fallback={<div>Loading slider...</div>}>
                        <Slider
                          {...settings}
                          appendDots={(dots) => (
                            <div className='custom-dots-container'>
                              <ul className='custom-dots'>{dots}</ul>
                            </div>
                          )}
                          customPaging={(i) => (
                            <div className='custom-dot'>
                              <span></span>
                            </div>
                          )}
                        >
                          {filledTemplates.map((item, index) => (
                            <div key={item?._id} className='template-slide'>
                              {item ? (
                                <div
                                  onClick={() => handleClick(item)}
                                  className={`tempaltebox ${
                                    activeIndex === item?._id
                                      ? "active-tempaltebox"
                                      : ""
                                  }`}
                                >
                                  <h4 className='name ms-2'>{`${String(
                                    index + 1
                                  ).padStart(2, "0")}. ${item?.name}`}</h4>
                                  <p className='text-[#6D727D] ms-2 min-h-[24px]'>
                                  {item?.description || ' '}
                                  </p>

                                  <div className='message-box'>
                                    <img
                                      src={smallpreviewpic}
                                      alt='Preview'
                                      className='template-image'
                                    />
                                  
                                    <p className='message min-h-10 overflow-auto'>
                                      {item?.message}
                                    </p>
                                  </div>
                                </div>
                              ) : (
                                <div className='empty-slide'></div> // Empty placeholder for missing items
                              )}
                            </div>
                          ))}
                        </Slider>
                      </Suspense>
                    </div>

                    {/* <h1 style={{ marginTop: '15px' }}>Create Custom campaign</h1> */}

                    {/* <div onClick={() => { setMessage(true); setActiveIndex(3); }} className={`custom-campaign-tempaltebox ${activeIndex === 3 ? 'active-custom-campaign-tempaltebox' : ''}`}>
                                            <h1>Create Custom campaign</h1>
                                            <p>Create custom campaign Message as per your needs.</p>
                                            <img src={arrowright} alt="" />
                                        </div> */}
                  </Form.Item>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <button
                      onClick={() => handlebackClick("targetuser")}
                      className='back-btn'
                    >
                      <img alt='' width={24} src={arrowleft} />
                      Back
                    </button>
                    <button
                      onClick={() => {
                        handleStepClick("daterange");
                      }}
                      className='btn'
                    >
                      Continue
                    </button>
                  </div>
                </div>
              )}

              {currentStep === "daterange" && (
                <div className='campaign-title'>
                  <p>Phishing Simulation Campaigns</p>
                  <h1>Select Date Range</h1>

                  {/* Send Immediately Button */}
                  <Button
                    type='default'
                    onClick={() => {
                      const now = moment();
                      const currentDate = now.format("YYYY-MM-DD");
                      const currentTime = now.format("HH:mm");

                      setDate(currentDate);
                      setTime(currentTime);

                      // Update Ant Form values too
                      form.setFieldsValue({
                        date: moment(currentDate, "YYYY-MM-DD"),
                        time: moment(currentTime, "HH:mm"),
                      });
                    }}
                    className='mb-2'
                  >
                    Send Immediately
                  </Button>

                  {/* Date and Time Pickers */}
                  <div
                    style={{ display: "flex", gap: "20px", marginTop: "10px" }}
                  >
                    <div className='d-flex aign-items-center mx-4'>
                      <Form.Item
                        name='date'
                        className='d-flex align-items-center py-3 '
                        label='Select Date'
                        rules={[
                          {
                            required: true,
                            message: "Date selection is required!",
                          },
                        ]}
                      >
                        <DatePicker
                          className='inputbox p-2 custom-range-picker'
                          format='YYYY-MM-DD'
                          disabledDate={disablePastDates}
                          onChange={(value) => {
                            const dateString = value
                              ? value.format("YYYY-MM-DD")
                              : "";
                            setDate(dateString);
                          }}
                          value={date ? moment(date, "YYYY-MM-DD") : null}
                          placeholder='Select Date'
                        />
                      </Form.Item>
                    </div>
                    <div className='d-flex aign-items-center'>
                      <Form.Item
                        name='time'
                        className='d-flex align-items-center p-3'
                        label='Select Time'
                        rules={[
                          {
                            required: true,
                            message: "Time selection is required!",
                          },
                        ]}
                      >
                        <TimePicker
                          className='inputbox p-2 custom-range-picker'
                          format='HH:mm'
                          {...disablePastTimes(date)}
                          onChange={(value) => {
                            const timeString = value
                              ? value.format("HH:mm")
                              : "";
                            setTime(timeString);
                          }}
                          value={time ? moment(time, "HH:mm") : null}
                          placeholder='Select Time'
                        />
                      </Form.Item>
                    </div>
                  </div>

                  {/* Display Selected Date & Time */}
                  <p className='datetime'>Campaign Date & Time:</p>
                  {date && time && (
                    <p className='timeonly'>{`${date} ${time}`}</p>
                  )}

                  {/* Navigation Buttons */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Button
                      onClick={() => handlebackClick("campaignTemplate")}
                      className='back-btn'
                    >
                      <img alt='' width={24} src={arrowleft} /> Back
                    </Button>
                    <Button
                      onClick={() => handleStepClick("review")}
                      className='btn'
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              )}

              {currentStep === "review" && (
                <div className='campaign-title'>
                  <p>Phishing Simulation Campaigns</p>
                  <h1>Review Campaign</h1>
                  <h2 className='text-lg text-[#3A3B3F]'>
                    Title of Campaign:{" "}
                    <p className='text-[#6D727D] text-md'>{name}</p>
                  </h2>

                  {!userdetails?.isFree ? (
                    <h2 className='text-lg text-[#3A3B3F]'>
                      Phone Number:
                      <p className='text-[#6D727D] text-md'>
                        {userdetails?.phone}
                      </p>
                    </h2>
                  ) : (
                    <h2 className='text-lg text-[#3A3B3F]'>
                      Target Groups:
                      {/* <p className="text-[#6D727D]">
                                            {selectedUsers.map((item) => (
                                                <span key={item._id}>{item.name}</span> // Display each user's name
                                            ))}
                                        </p> */}
                      <p className='text-[#6D727D] text-md'>
                        {selectedUsers.map((item, index) => (
                          <span key={item._id}>
                            {item.name}
                            {
                              index < selectedUsers.length - 1 &&
                                " " /* Add space between names */
                            }
                          </span>
                        ))}
                      </p>
                    </h2>
                  )}

                  <h2 className='text-lg text-[#3A3B3F]'>
                    Your Campaign Message:{" "}
                    <p className='text-[#6D727D] text-md'>
                      {selectedtemplate?.message || campaignmessage}
                    </p>
                  </h2>
                  {selecteddomain && selectedlogintemplate && (
                    <div className='bg-[#FEF2F2] px-4 py-2 rounded-2xl w-fit flex gap-3 items-center mb-2'>
                      <div>
                        <h5 className='text-lg text-[#3A3B3F]'>
                          {selectedtemplate?.name}
                        </h5>
                        <p className='bg-white text-sm px-2 py-1 rounded-full text-[#363636]'>
                          &bull;{selecteddomain?.url}
                        </p>
                      </div>
                      <img src={exchange} alt='exchange' className='w-6 h-6' />
                    </div>
                  )}
                  <h2 className='text-lg text-[#3A3B3F] capitalize'>
                    Campaign Date & Time:
                    {/* <p className="text-[#6D727D]">{formatDisplay(dateRange)}</p> */}
                    <p className='text-[#6D727D]'>
                      {date} {time}
                    </p>
                  </h2>
                  <div className='flex justify-between gap-3 flex-wrap'>
                    <Button
                      onClick={() => handlebackClick("daterange")}
                      className='back-btn'
                    >
                      <IoIosArrowRoundBack size={24} />
                      Back
                    </Button>
                    <Button onClick={savecampaign} className='btn'>
                      Save
                    </Button>
                  </div>
                </div>
              )}
            </Form>
          </div>
        </div>
      </div>

      <CampaignNotification
        visible={notificationmodal}
        onClose={() => setNotificationmodal(false)}
        campaign={campaign}
      />

      <CampaignMessagepreview
        visible={messagepreview}
        onClose={() => setmessagepreview(false)}
        selectedtemplate={selectedtemplate}
      />
      <CampaignMessagepreview2
        visible={messagepreview2}
        onClose={() => setmessagepreview2(false)}
        selectedtemplate={selectedtemplate}
        setSelecteddomain={setSelecteddomain}
        setSelectedloginTempalte={setSelectedloginTempalte}
        Selecteddomain={selecteddomain}
        SelectedloginTempalte={selectedlogintemplate}
      />

      <CampaignMessage
        visible={message}
        onClose={() => setMessage(false)}
        setcampaignmessage={setcampaignmessage}
        campaignmessage={campaignmessage}
        setcampaignTemplate={setcampaignTemplate}
        userdetails={userdetails}
      />

      {/* 
            <InsertTemplate
              visible={insertemplate}
              onClose={() => setInsertTemplate(false)}
              userdetails={userdetails}
            
            /> */}
    </>
  );
};

export default FreeusercampaignFlow;
